// src/publicPath.js
// Must be the FIRST import in index.js.
//
// The build loads its page files ("chunks") relative to the page you're on.
// On a deep link like /JobChecklist/abc that meant the browser asked for
// /JobChecklist/static/js/5622.chunk.js - which doesn't exist, so the server
// sent the HTML page back: "Unexpected token '<'" / "Loading chunk failed".
// This pins every chunk to the site root (/static/js/...), whatever the URL.
// (The cause is "homepage": "." in package.json; changing it to "/" fixes the
// main files too. This makes the chunks right either way.)
/* eslint-disable no-undef, camelcase */
__webpack_public_path__ = "/";
